import { render, staticRenderFns } from "./SelectableGroup.vue?vue&type=template&id=672c92b2&"
import script from "./SelectableGroup.vue?vue&type=script&lang=js&"
export * from "./SelectableGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports